import * as angular from 'angular';
import {BillingOrdersRequests} from "./billing-orders-requests.service";
import {IHttpService, IQService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {BillingAlertsService} from "./billing-alerts.service";
import {ExportBillingOrdersTablePayloadModel} from "../models/export-billing-orders-table-payload.model";
import {ApiConfig} from "../../commons/models/api-config.model";

export class BillingOrderService {

  private base_url: any;

  /* @ngInject */
  constructor(private $q: IQService, private $http: IHttpService, private $log, private splitService: SplitService, private apiConfig: ApiConfig,
              private bringozLoaderService: BringozLoaderService, private billingAlertsService: BillingAlertsService, private billingOrdersRequests: BillingOrdersRequests) {
    this.base_url = this.apiConfig.baseUrl + `/billingOrders`;
  }

  getBillingOrder(id) {
    const deferred = this.$q.defer();
    this.billingOrdersRequests.getBillingOrder(id)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        // this.billingAlertsService.getBillingOrderPriceOfferError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getPrice(billingOrderId) {
    const deferred = this.$q.defer();
    this.bringozLoaderService.on();
    this.billingOrdersRequests.getPrice(billingOrderId)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.billingAlertsService.getBillingOrderPriceOfferError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updatePrice(billingOrderId, priceOffer, showSuccessMessage?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.billingOrdersRequests.updatePrice(billingOrderId, priceOffer)
      .then((res) => {
        if (showSuccessMessage) {
          this.billingAlertsService.updateBillingOrderPriceOfferSuccess();
        }
        deferred.resolve(res);
      })
      .catch((error) => {
        if (error.code === 412002) {
          this.billingAlertsService.updateBillingOrderPriceOfferError(error);
        } else {
          this.billingAlertsService.updateBillingOrderPriceOfferError();
        }
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  createInvoice(invoice) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.billingOrdersRequests.createInvoice(invoice)
      .then((res) => {
        this.billingAlertsService.invoiceCreationRequestSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.billingAlertsService.invoiceCreationRequestError(error);
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteInvoice(billingOrderId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.billingOrdersRequests.deleteInvoice(billingOrderId)
      .then((res) => {
        this.billingAlertsService.deleteInvoiceSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.billingAlertsService.deleteInvoiceError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  syncPrice(billingOrderId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.billingOrdersRequests.syncPrice(billingOrderId)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.billingAlertsService.syncPriceOfferError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  exportCSV(payload: ExportBillingOrdersTablePayloadModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.billingOrdersRequests.exportCSV(payload)
      .then((res) => {
        this.billingAlertsService.exportSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.billingAlertsService.exportError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }


  manualPaid(billingOrderId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.billingOrdersRequests.manualPaid(billingOrderId)
      .then((res) => {
        this.billingAlertsService.manualPaidSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.billingAlertsService.manualPaidError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }


  getBillingOrderInvoice(billingOrderId) {
    const deferred = this.$q.defer<any>();
    this.bringozLoaderService.on();

    this.$http.get(this.base_url + `/${billingOrderId}/invoice/pdf`, {
      params: {
        siteId: this.splitService.getSiteId(),
      },
      responseType: "arraybuffer"
    })
      .then((response) => {
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.getBillingOrderInvoiceError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getBillingOrderConsolidateInvoice(consolidateInvoiceId) {
    const deferred = this.$q.defer<any>();
    this.bringozLoaderService.on();

    this.$http.get(this.base_url + `/consolidateInvoice/pdf`, {
      params: {
        consolidateInvoiceId: consolidateInvoiceId,
        siteId: this.splitService.getSiteId(),
      },
      responseType: "arraybuffer"
    })
      .then((response) => {
        deferred.resolve(response);
      })
      .catch((error) => {
        this.billingAlertsService.getBillingOrderInvoiceError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }


}

angular
  .module('bringoz.admin.billing-accounts')
  .service('billingOrderService', BillingOrderService);
